import http from '@/axios/http'
import { getuser_id, getroleId } from "@/localStorage/localStorage";

//新增客户
export function newCustomer({
    c_name,
    username,
    password,
    cUrl,
    cContact,
    cTel,
    cInfo,
    cProvince,
    cCity,
    cDistrict,
    cStreet,
    cAddress,
    cLongitude,
    cLatitude,
    cEmail,
    // supportSuperlink,
    productType,
    userRoleid,
    copyRight
}, language) {
    const data = {
        userId: getuser_id(),
        cName: c_name,
        username: username,
        password: password,
        cUrl: cUrl,
        cContact: cContact,
        cTel: cTel,
        cInfo: cInfo,
        cProvince: cProvince,
        cCity: cCity,
        cDistrict: cDistrict,
        cStreet: cStreet,
        cAddress: cAddress,
        cLongitude: cLongitude,
        cLatitude: cLatitude,
        cEmail: cEmail,
        // supportSuperlink: supportSuperlink,
        productType: productType,
        roleId: parseInt(userRoleid),
        language: language,
        copyRight
    }
    return http({
        url: '/api/customer/newCustomer',
        method: 'post',
        data
    })
}

//获取客户列表
export function getCustomerList(offset, limit) {
    const data = {
        user_id: getuser_id(),
        offset: offset,
        limit: limit
    }
    return http({
        url: '/api/customer/getCustomerList',
        method: 'post',
        data
    })
}

//删除客户
export function deleteCustomer(cid) {
    const data = {
        user_id: getuser_id(),
        cid: cid
    }
    return http({
        url: '/api/customer/deleteCustomer',
        method: 'post',
        data
    })
}

//获取当前用户可赋予的身份
//权限管理角色列表
export function getFunctionalAuthority(language) {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 99999,
        language: language
    }
    return http({
        url: '/api/permission/getFunctionalAuthority',
        method: 'post',
        data
    })
}

//修改客户信息
export function updateCustomer({
    c_id,
    c_name,
    userRoleid,
    cUrl,
    cTel,
    cProvince,
    cCity,
    cDistrict,
    cStreet,
    cLongitude,
    cLatitude,
    cAddress,
    cEmail,
    cContact,
    copyRight
}) {
    const data = {
        cId: c_id,
        cName: c_name,
        // supportSuperlink: supportStatus,
        roleId: userRoleid,
        cUrl: cUrl,
        cTel: cTel,
        cProvince: cProvince,
        cCity: cCity,
        cDistrict: cDistrict,
        cStreet: cStreet,
        cLongitude: cLongitude,
        cLatitude: cLatitude,
        cAddress: cAddress, //详细地址
        cEmail: cEmail,
        cContact: cContact,
        copyRight
    }
    return http({
        url: '/api/customer/updateCustomer',
        method: 'post',
        data
    })
}

//搜索
export function queryKeyword(keyword, offset, limit, sort) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        cname: sort.cname,
        cid: sort.cid,
        username: sort.username,
        contact: sort.contact,
        tel: sort.tel,
        email: sort.email,
        address: sort.address,
        superlink: sort.superlink
    }
    return http({
        url: '/api/customer/queryKeyword',
        method: 'post',
        data
    })
}
